import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'bars',
            name: 'bar',
            class: 'Modules\\Bar\\Entities\\Bar',
            forms: {
                DIPLOMA: 'image-bars-form',
                SELLOS: 'image-bars-form'
            },
            defaultBarsForm: 'default-bars-form'
        }
    },

    methods: {
        addForm(barName, component) {
            this.forms[barName] = component

            return this
        },

        getForm(barName) {
            return this.forms[barName] ?? this.defaultBarsForm
        }
    }
}